module.exports = __webpack_public_path__ + "img/ticket-005.913f7e79.svg";